import type { Coach } from '@entities/coaches/index';
import {
  SDescription,
  SName,
  SSpecialization,
} from '@features/coaches/coachCard/coacheStyledComponents';
import { HomeIconMenu, OnlineIcon } from '@shared/assets/index';
import { getFullNameM } from '@shared/helpers/index';
import { CoachAvatar } from '../coachAvatar/ui';
import { SAdditionalInfo, SCard, SConsultationCost, SHomeIconMenu } from './styles';

type PT = Partial<Coach> & { onClick: () => void };

export const CoachCardSmall = ({
  photo,
  first_name,
  middle_name,
  last_name,
  consultation_cost,
  consultation_offline_cost,
  onClick,
  module,
  // address,
}: PT) => {
  return (
    <SCard onClick={onClick}>
      <CoachAvatar photo={photo} />

      <SDescription>
        <SName>{getFullNameM(first_name, middle_name, last_name)}</SName>

        {module && <SSpecialization>{module.verbose_name}</SSpecialization>}

        <SConsultationCost>
          {consultation_cost && (
            <>
              <OnlineIcon />
              {/*<span>{doFormatBigNumbers(consultation_cost)} RUB</span>*/}
            </>
          )}

          {consultation_offline_cost && (
            <SHomeIconMenu>
              <HomeIconMenu />
              {/*<span>{doFormatBigNumbers(consultation_offline_cost)} RUB</span>*/}
            </SHomeIconMenu>
          )}
        </SConsultationCost>
      </SDescription>

      <SAdditionalInfo>
        {/*<SCountOfAvailableConsultations>*/}
        {/*	-1*/}
        {/*</SCountOfAvailableConsultations>*/}

        {/*<SCity>*/}
        {/*	{address?.city}*/}
        {/*</SCity>*/}
      </SAdditionalInfo>
    </SCard>
  );
};
